import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)
//
let actions = {
  page: {
    'method': 'GET',
    'url': '/api/v1/questionnaires'
  },
  all: {
    'method': 'GET',
    'url': '/api/v1/questionnaires/posts'
  },
  full: {
    'method': 'GET',
    'url': '/api/v1/questionnaires{/_id}/full'
  }
}

export default Vue.resource('/api/v1/questionnaires{/_id}', {}, actions)



// WEBPACK FOOTER //
// ./src/resource/post.js